<template>
  <v-app>
    <div v-if="isAuthenticated">
      <v-navigation-drawer
        fixed
        v-model="drawer"
        clipped
        app
      >
        <v-toolbar flat class="blue-grey darken-3">
          <v-list-item>
            <v-list-item-avatar>
              <img :src="loggedInPicture" >
            </v-list-item-avatar>
            <v-list-item-title>
              <span class="white--text">{{loggedInName}}</span>
            </v-list-item-title>
          </v-list-item>
        </v-toolbar>

        <v-list dense>
          <v-list-item v-for="item in menuItems" :key="item.text" @click="navigate(item)" :disabled="item.disabled">
            <v-list-item-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar
        app
        :clipped-left="true"
        color="blue-grey lighten-5"
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>
          <img src="/static/img/timepark-logo.png" width="180" />
        </v-toolbar-title>
        <v-spacer />
        <v-progress-linear :active="!initialized" indeterminate absolute bottom/>
        <v-btn icon @click="logout">
          <v-icon>mdi-lock</v-icon>
        </v-btn>
      </v-app-bar>

      <v-main class="ma-2">
        <router-view :auth="auth" v-if="initialized"/>
      </v-main>
      <v-footer app class="pa-3">
        <span class="subtitle-2">
          <strong>Version:</strong> {{ appversion }}
        </span>
        <v-spacer></v-spacer>
        <a target="_blank" class="copyright" href="http://www.softwarepark.cc">Softwarepark Services GmbH © {{ new Date().getFullYear() }}</a>
      </v-footer>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import timeparkApi from '../timeparkApi';

export default {
  props: ['auth'],
  watch: {
    currentUserIsAdministrator(newVal) {
      this.items = this.createMenuItems(newVal);
    },
  },
  async mounted() {
    if (!this.auth.isAuthenticated()) {
      this.auth.login();
      return;
    }

    await this.initializeData();
  },
  methods: {
    async initializeData() {
      const { data: version } = await timeparkApi.getVersion();
      this.appversion = version;

      await this.$store.dispatch('loadProducts');
      await this.$store.dispatch('loadMachines');

      const { data: systemSettings } = await timeparkApi.getSystemSettings();
      this.$store.commit('updateSystemSettings', systemSettings)

      const { data: timeRecordingMetadataDefinitions } = await timeparkApi.getTimeRecordingMetadataDefinitions();
      this.$store.commit('setTimeRecordingMetadataDefinitions', timeRecordingMetadataDefinitions);

      const { data: userMetadataDefinitions } = await timeparkApi.getUserMetadataDefinitions();
      this.$store.commit('setUserMetadataDefinitions', userMetadataDefinitions);

      const { data: timeModels } = await timeparkApi.getTimeModels();
      this.$store.commit('setTimeModels', timeModels);

      const { data: extraCharges } = await timeparkApi.getExtraCharges();
      this.$store.commit('setExtraCharges', extraCharges);

      this.initialized = true;
    },
    logout() {
      this.auth.logout();
      this.isAuthenticated = false;
      this.auth.login();
    },
    navigate(item) {
      this.$router.push({
        path: item.link,
        query: item.params,
      });
    },
    createMenuItems(isAdmin) {
      return [
        { icon: 'mdi-chart-pie', text: 'Home', link: '/', disabled: false },
        { icon: 'mdi-alarm', text: 'Zeiten', link: '/zeiten', disabled: false },
        { icon: 'mdi-folder', text: 'Produkte', link: '/produkte', disabled: !isAdmin },
        { icon: 'mdi-car', text: 'Fahrzeuge', link: '/fahrzeuge', disabled: !isAdmin },
        { icon: 'mdi-account-supervisor', text: 'Personen', link: '/personen', disabled: !isAdmin },
        { icon: 'mdi-arrow-left-right', text: 'Export Settings', link: '/exportersettings', disabled: !isAdmin },
        { icon: 'mdi-brightness-percent', text: 'Lohnarten', link: '/lohnarten', disabled: !isAdmin },
      ];
    },
  },
  computed: {
    menuItems() {
      return this.items;
    },
    ...mapGetters(['currentUserIsAdministrator'])
  },
  data() {
    return {
      isAuthenticated: this.auth.isAuthenticated(),
      loggedInName: this.auth.getLoggedInName(),
      loggedInPicture: this.auth.getLoggedInPicture(),
      drawer: false,
      items: this.createMenuItems(this.currentUserIsAdministrator),
      initialized: false,
      appversion: '',
    };
  },
};
</script>

